import React from 'react'
import { useTheme } from '@mui/material'
import { ElementProps } from '../models'
import FieldLabel from './FieldLabel'
import ErrorMessage from './ErrorMessage'
import useCustomStyles from '../../utils/hooks/CustomStylesHook'

const styles = () => ({
  fieldSetFlex: { display: 'flex !important', width: '100% !important' },
  errorBorder: { borderColor: 'red' },
})

const TextField = ({
  component,
  state,
  handleChange,
  disabled = false,
  errorMessage,
}: ElementProps) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  return (
    <div className={`fieldSet ${classes?.fieldSetFlex}`}>
      <FieldLabel label={component.label} required={component.required} />
      <div>
        <input
          type='text'
          value={state[component.reference] ?? ''}
          name={component.reference}
          placeholder={component.placeHolder}
          required={component.required}
          disabled={disabled}
          onChange={(e) => handleChange(e.target.value, component)}
          className={errorMessage ? classes?.errorBorder : ''}
        />
        <ErrorMessage errorMessage={errorMessage} />
      </div>
    </div>
  )
}

export default TextField
